import { render, staticRenderFns } from "./valorCbhpm.vue?vue&type=template&id=9b738658"
import script from "./valorCbhpm.vue?vue&type=script&lang=js"
export * from "./valorCbhpm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports